import { render, staticRenderFns } from "./BtnAprovarConformidadeTecnica.vue?vue&type=template&id=74216a24"
import script from "./BtnAprovarConformidadeTecnica.vue?vue&type=script&lang=js"
export * from "./BtnAprovarConformidadeTecnica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports